import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

import MenuSubListItem from 'components/Pages/Menu/MenuSubList/MenuSubListItem';

const MenuSubList = ({ list, onClick }) => (
  <>
    <Label className="label" message="All sports" />
    <div className="tab-container-list menu">
      {list?.map(({ id, name }) => (
        <MenuSubListItem id={id} key={name} name={name} onClick={() => onClick(id)} />
      ))}
    </div>
  </>
);

MenuSubList.propTypes = {
  list: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MenuSubList;
